import powerBIIcon from "static/images/landing-page/integration-support/powerBI-logo.svg";
import tableauIcon from "static/images/landing-page/integration-support/tableau-logo.svg";
import excelIcon from "static/images/landing-page/integration-support/excel-logo.svg";
import qlikSenseIcon from "static/images/landing-page/integration-support/Qlik-Sense.svg";
import qlikViewIcon from "static/images/landing-page/integration-support/qlikView-logo.svg";

type IntegrationSupportItem = {
  title: string;
  imageUrl: string;
};

export default function IntegrationSupportBanner() {
  const integrationSupportImages: IntegrationSupportItem[] = [
    {
      title: "power b i",
      imageUrl: powerBIIcon,
    },
    {
      title: "tableau",
      imageUrl: tableauIcon,
    },
    {
      title: "excel",
      imageUrl: excelIcon,
    },
    {
      title: "qlik",
      imageUrl: qlikSenseIcon,
    },
    {
      title: "qlik View",
      imageUrl: qlikViewIcon,
    },
  ];

  return (
    <div className="flex flex-wrap justify-center xxl:justify-start">
      <span className="mr-9 mt-4 shrink-0">Integrates with:</span>
      <div>
        <div className="flex gap-x-6 flex-wrap justify-center">
          {integrationSupportImages.map(
            (item: IntegrationSupportItem, index: number) => {
              return <img key={index} src={item.imageUrl} alt={item.title} />;
            }
          )}
        </div>
      </div>
    </div>
  );
}
